
import {defineComponent, onMounted, PropType, reactive, ref, watch} from "vue";
import InputText from "primevue/inputtext";
import Dropdown from 'primevue/dropdown';
import {UserRole} from "@dex/squeeze-client-ts";
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import {useI18n} from "vue-i18n";
import {useToast} from "primevue/usetoast";

export default defineComponent({
	name: "RoleForm",
	components: {
		InputText, Dropdown,
	},
	props: {
		role: {
			type: Object as PropType<UserRole>,
			required: true,
		},
		parentRoles: {
			type: Array as PropType<UserRole>,
			required: true,
		},
		showErrorMessage: {
			type: Boolean,
		},
	},
	emits: ['update'],
	setup(props, {emit}) {
		const {t} = useI18n();
		const toast = useToast();

		/** Show loading? */
		const loading = ref(false);

		/** Current Object of all input-fields */
		const value = reactive<any>({
			title: '',
			description: '',
			parentRoleId: 0,
		});

		/** Determines the required rules for validation */
		const rules = {
			title: { required },
			description: { required },
			parentRoleId: { required },
		}

		/** Use Vuelidate */
		const v$ = useVuelidate(rules, value);

		onMounted(async () => {
			Object.assign(value, props.role);

			// Emit Validated-Values onMounted. Otherwise there can be validation-errors when editing multiple entries
			await v$.value.$validate();
		});

		/** Watch prop at set value object, because props are not allowed to be mutated */
		watch(props.role, async () => {
			Object.assign(value, props.role);
			await v$.value.$validate();
			emit("update", value, v$.value.$invalid);
		})

		/** Triggered on change of any field */
		const update = () => {
			emit("update", value, v$.value.$invalid);
		}

		return {
			t,
			toast,
			loading,
			value,
			props,
			v$,
			InputText,
			Dropdown,
			update,
		}
	},
});

